import { ReactNode } from "react";
import "../assets/SimpleTextWrapper.css";

interface Props {
  children: ReactNode;
  textColor?: string;
  fontFamily?: string;
  className?: string;
}

function HtmlContentWrapper({
  children,
  className,
  textColor,
  fontFamily,
}: Props) {
  return (
    <div
      className={`ql-editor ${className || ""}`}
      style={{ color: textColor, fontFamily }}
    >
      {children}
    </div>
  );
}

export default HtmlContentWrapper;
